import { InjectionToken } from '@angular/core';

/**
 * Pure interface so that `src/shared/ui` never depends on a concrete tracking/business service.
 * Bootstraps provide the real implementation (backed by `TrackingService.trackUserClick`).
 */
export interface DropdownClickTracker {
  track(location: string, action: string): void;
}

/**
 * Optional injection point used by the dropdown/menu renderer to report clicks on
 * `DropdownItem`s that opt in via `trackingAction`/`trackingLocation`. Left unprovided,
 * dropdown UI keeps working with zero tracking side effects.
 */
export const DROPDOWN_CLICK_TRACKER: InjectionToken<DropdownClickTracker> = new InjectionToken<DropdownClickTracker>(
  'DROPDOWN_CLICK_TRACKER'
);
